import * as angular from 'angular';
import {LocationHolderType} from "../types/locationHolder.type";
import {$bringozLocationsFactory} from "../$bringozLocations.factory";


export class LocationRequestsService {

  /* @ngInject */
  constructor(private LocationAPI, private $bringozLocations: $bringozLocationsFactory) {
  }

  getLocations(payload: {holderId: string, holder: LocationHolderType}[]) {
    const api = this.LocationAPI.actions.getLocations;
    return this.$$call(api, {}, payload, {});
  }

  getAgentLocation(id: string) {
    const api = this.LocationAPI.actions.getAgentLocation;
    return this.$$call(api, {}, {}, {id: id});
  }

  getLogisticsVehicleLocation(id: string) {
    const api = this.LocationAPI.actions.getLogisticsVehicleLocation;
    return this.$$call(api, {}, {}, {id: id});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params?, _data?, _options?) {
    return this.$bringozLocations().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.commons')
  .service('locationRequestsService', LocationRequestsService);
